// extracted by mini-css-extract-plugin
export default {"Box":"table-group-contents-module__Box--A_YYg","disabledFooter":"table-group-contents-module__disabledFooter--d_oyX"};